module.exports = __webpack_public_path__ + "img/sa.03fc3950.svg";